import { useEffect, useMemo, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import branding from "@config/branding.json";
import theme from "@config/theme.json";
import en from "./i18n/en.json";
import mr from "./i18n/mr.json";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import Chatbot from "./components/Chatbot.jsx";
import LoadingScreen from "./components/LoadingScreen.jsx";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import ProductPage from "./pages/ProductPage.jsx";
import Branches from "./pages/Branches.jsx";
import Careers from "./pages/Careers.jsx";
import Contact from "./pages/Contact.jsx";
import Downloads from "./pages/Downloads.jsx";
import fdProducts from "@config/fd-products.json";
import rdProducts from "@config/rd-products.json";
import dailyProducts from "@config/daily-products.json";
import goldProducts from "@config/gold-products.json";
import { applyTheme, setSeo } from "./lib/site.js";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import AdminLogin from "./pages/AdminLogin.jsx";
import Login from "./pages/Login.jsx";

const dictionaries = { en, mr };

export default function App() {
  const [lang, setLang] = useState("en");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const t = useMemo(() => dictionaries[lang], [lang]);

  useEffect(() => {
    applyTheme(theme);
    const timer = window.setTimeout(() => setLoading(false), 650);
    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    const pageTitle = t.nav.find((item) => item.to === location.pathname)?.label;
    setSeo({
      title: pageTitle ? branding.seo.titleTemplate.replace("%s", pageTitle) : branding.seo.defaultTitle,
      description: branding.seo.description,
      keywords: branding.seo.keywords,
      image: branding.seo.image,
      url: `https://${branding.domain}${location.pathname}`
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, t]);

  return (
    <div className="min-h-screen bg-[var(--surface-soft)] text-ink">
      {loading && <LoadingScreen branding={branding} />}
      <Header branding={branding} lang={lang} setLang={setLang} t={t} />
      <main>
        <Routes>
          <Route path="/" element={<Home t={t} branding={branding} />} />
          <Route path="/about" element={<About t={t} branding={branding} />} />
          <Route path="/fixed-deposits" element={<ProductPage type="fd" t={t} products={fdProducts} />} />
          <Route path="/recurring-deposits" element={<ProductPage type="rd" t={t} products={rdProducts} />} />
          <Route path="/daily-collection" element={<ProductPage type="daily" t={t} products={dailyProducts} />} />
          <Route path="/gold-loan" element={<ProductPage type="gold" t={t} products={goldProducts} />} />
          <Route path="/branches" element={<Branches t={t} />} />
          <Route path="/careers" element={<Careers t={t} />} />
          <Route path="/downloads" element={<Downloads t={t} />} />
          <Route path="/contact" element={<Contact t={t} branding={branding} />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<Login />} />
          
        </Routes>
      </main>
      <Chatbot t={t} />
      <Footer branding={branding} t={t} />
    </div>
  );
}
